import { asyncLoad } from '@util'
const AsyncCreate = asyncLoad(() =>
  import('@components/LocalMerchant/VR/Detail/Create')
)

export default {
  path: 'create',
  component: AsyncCreate
}
